var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "key-art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209,
    height: 162.13,
    viewBox: "0 0 209 162.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#795698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#965c92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#cd6988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e36e85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#dc6c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#795698"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.499,
    cy: 0.5,
    r: 0.554,
    gradientTransform: "translate(0.001 -0.037) scale(0.866 0.943)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efd045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#eecc47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#edc24e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ebb059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e89769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e4777e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e36e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -1.094,
    x2: 0.5,
    y2: 0.365,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e29982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#795698"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: -3.215,
    x2: 0.5,
    y2: -1.007,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.275,
    cy: 1.503,
    r: 3.35,
    gradientTransform: "translate(-0.491 -341.063) scale(0.153 0.361)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eac192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7996d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.275,
    cy: 0.866,
    r: 3.482,
    gradientTransform: "translate(-0.495 -382.515) scale(0.147 0.349)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eac192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1b680"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.34,
    cy: 3.207,
    r: 2.61,
    gradientTransform: "translate(-0.542 -370.513) scale(0.118 0.398)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe4a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4c7a1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.492,
    cy: 0.489,
    r: 0.425,
    gradientTransform: "translate(9.759) scale(1.522 1)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.494,
    cy: 0.491,
    r: 0.429,
    gradientTransform: "translate(8.137) scale(1.472 1)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.495,
    cy: 0.489,
    r: 0.425,
    gradientTransform: "translate(9.409) scale(1.522 1)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.498,
    cy: 0.49,
    r: 0.435,
    gradientTransform: "translate(6.42) scale(1.395 1)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.122,
    cy: -0.023,
    r: 1.512,
    gradientTransform: "translate(-0.539) scale(0.519 1)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.725,
    y1: 0.77,
    x2: 0.035,
    y2: -0.051,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f3daa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f2d29e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f0bf9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ee9e96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#eb718f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e63886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e51f83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 122.3,
    y1: 24.73,
    x2: 121.656,
    y2: 23.609,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7710",
    "data-name": "Path 7710",
    d: "M94.08,94.84V83L78.9,78.33V94.65Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7712",
    "data-name": "Path 7712",
    d: "M125.06,94.86V83.02l15.19-4.68V94.67Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.003,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edd49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e89b9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0,
    y1: 0.5,
    x2: 0.997,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1271",
    "data-name": "Group 1271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    "data-name": "Group 1269"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1410",
    "data-name": "Rectangle 1410",
    width: 123.21,
    height: 30.8,
    rx: 14.91,
    transform: "translate(48.75 110.76)",
    fill: "#fff",
    stroke: "#bea77e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7658",
    "data-name": "Path 7658",
    d: "M100.46,124.23l-8.66,1.33v4.82a2.028,2.028,0,0,0,.24,1.12c.16.21.51.31,1.05.31h3.54a2.393,2.393,0,0,0,1.52-.42c.35-.24.63-1.03.87-2.32l1.57.68a6.056,6.056,0,0,1-1.27,3,2.272,2.272,0,0,1-1.59.61H92.41a2.179,2.179,0,0,1-1.73-.7,2.955,2.955,0,0,1-.52-1.89V125.8l-4.9.75-.07-1.5,4.97-.77v-5.99l1.9.26c.23.03.35.12.35.28a.757.757,0,0,1-.33.51.634.634,0,0,0-.28.59v4.1l8.52-1.31.14,1.5Z",
    fill: "#ceb589"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7659",
    "data-name": "Path 7659",
    d: "M106.94,125.66c.17.05.28.12.28.21,0,.05-.05.12-.14.21a1.6,1.6,0,0,0-.49.68h3.49v-1.43l1.43.11c.26.04.4.1.4.23,0,.09-.09.23-.26.42v.68h5.38v1.36h-5.38v1.43h4.48v1.29h-4.48v1.36h6.06v1.36H102.79v-1.36h7.3v-1.36H105.8v-1.29h4.29v-1.43h-4.22a16.505,16.505,0,0,1-1.5,2.18l-1.5-.82a14.165,14.165,0,0,0,2.72-4.29l1.36.47Zm9.14-6.88v6.2H105.03v-6.2Zm-1.57,2.51v-1.15H106.6v1.15h7.91Zm0,1.23H106.6v1.1h7.91v-1.1Z",
    fill: "#ceb589"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7660",
    "data-name": "Path 7660",
    d: "M125.79,119.86c.16.07.24.16.24.28,0,.07-.19.16-.54.26a16.04,16.04,0,0,1-1.89,3.7,16.564,16.564,0,0,1-2.36,2.65l-1.55-1.03a13.938,13.938,0,0,0,2.58-2.76,14.528,14.528,0,0,0,1.83-3.65l1.68.54Zm6.58,5.19a33.039,33.039,0,0,1-.38,6.48,2.547,2.547,0,0,1-1.05,1.8,5.725,5.725,0,0,1-2.86.52l-.75-1.57a5.916,5.916,0,0,0,2.58-.3,1.691,1.691,0,0,0,.59-1.06,19.1,19.1,0,0,0,.35-4.43h-3.58a11.343,11.343,0,0,1-.7,3.33,8.422,8.422,0,0,1-1.57,2.44,9.182,9.182,0,0,1-2.51,1.73l-1.5-1.17a7.043,7.043,0,0,0,2.55-1.43,5.849,5.849,0,0,0,1.48-2.06,9.543,9.543,0,0,0,.68-2.84h-2.6v-1.43h9.27Zm-.82-6.27a7.873,7.873,0,0,0,1.5,4.21,15.04,15.04,0,0,0,3,2.74l-1.5,1.03a14.709,14.709,0,0,1-3.37-3.44,7.281,7.281,0,0,1-1.15-3.06h-3.46v-1.48h4.97Z",
    fill: "#ceb589"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7661",
    "data-name": "Path 7661",
    d: "M152.61,120.14H139.73v11.78h13.3v1.43h-13.3v.63h-1.57V118.71h14.45v1.43Zm-6.8,6.13v4.85h-4.85v-4.85Zm-1.43,1.29h-1.99v2.25h1.99Zm5.72-6.54v4.43h-7.5v-4.43Zm-1.43,1.3h-4.64v1.83h4.64Zm3.26,3.95v4.85h-4.9v-4.85Zm-1.43,1.29h-2.04v2.25h2.04Z",
    fill: "#ceb589"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    "data-name": "Group 1268"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 19.43,
    cy: 19.43,
    r: 19.43,
    transform: "translate(36.96 105.81)",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7662",
    "data-name": "Path 7662",
    d: "M56.46,120.38l-3.79,1.91v-3.01l4.57-2.42h2.47v16.47H56.46V120.39Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1270",
    "data-name": "Group 1270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7663",
    "data-name": "Path 7663",
    d: "M29.5,155.67l-.7.76a14.2,14.2,0,0,0-1.87-1.36l.74-.75a10.492,10.492,0,0,1,1.82,1.35Zm.09,2.35a38.141,38.141,0,0,1-1.6,3.51c0,.24-.06.37-.18.37l-.89-.71a24.125,24.125,0,0,0,2.05-3.93l.61.76Zm.57-5.45-.66.71a12.8,12.8,0,0,0-1.77-1.26l.71-.71a11.922,11.922,0,0,1,1.73,1.26Zm7.07,4.6v3.47h.66v.94H29.73v-.94h.74v-3.47h6.75Zm-.42-5.66v4.73H30.86v-4.73Zm-4.35,9.12v-2.57h-.95v2.57Zm3.32-6.25v-2.04H31.89v2.34a7.559,7.559,0,0,0,1.73-2.24l.88.2c.13.02.2.07.2.12,0,.1-.08.17-.24.24-.1.16-.2.3-.3.44A5.84,5.84,0,0,0,35.78,154.38Zm0,.08-.66.7a6.439,6.439,0,0,1-1.39-1.12,12.006,12.006,0,0,1-1.04,1.12l-.79-.4v.64h3.89v-.94Zm-1.45,6.17v-2.57h-.94v2.57Zm1.87,0v-2.57h-.94v2.57Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7664",
    "data-name": "Path 7664",
    d: "M42.36,157.59a.815.815,0,0,1,.36-.18,6.468,6.468,0,0,1,.8.68.245.245,0,0,1,.08.16.141.141,0,0,1-.1.14,1.721,1.721,0,0,0-.42.55,4.9,4.9,0,0,1-1.32,1.46,7.07,7.07,0,0,1-2.1.98l-.74-.84a10.219,10.219,0,0,0,1.43-.44,5.1,5.1,0,0,0,1-.6,4.745,4.745,0,0,0,.83-.97H39.53v-.95h2.83Zm2.69-6.31c.17.02.25.08.25.18,0,.08-.1.18-.29.28l-.25.42h3.59v4.59H45.28a8.355,8.355,0,0,0,1.14,1.66,14.159,14.159,0,0,0,2.03-1.24l.8.8a.344.344,0,0,1,.08.18c0,.1-.13.14-.37.14-.59.3-1.19.59-1.8.86a7.722,7.722,0,0,0,2.78,1.52l-.95.98a9.149,9.149,0,0,1-3.01-2.09,7.548,7.548,0,0,1-.92-1.16v2.27c0,.65-.14,1.04-.42,1.21a4.679,4.679,0,0,1-1.73.19l-.34-.94a8.622,8.622,0,0,0,1.26-.05c.12-.05.19-.18.19-.42v-3.93H40.65v-4.59h2.91l.55-1.08.92.2Zm2.21,2.76v-.95H41.73v.95Zm0,.88H41.73v.89h5.53Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7665",
    "data-name": "Path 7665",
    d: "M57.12,158.01a11.786,11.786,0,0,0-2.16-2.29l.7-.78a16.316,16.316,0,0,1,2.3,2.33l-.84.74Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7666",
    "data-name": "Path 7666",
    d: "M67.19,152.07v.94h-1.7c-.13.95-.28,1.71-.42,2.29h2.07v5.16H65.27v.89h-.98v-4.04c-.17.32-.34.62-.52.9l-.94-.61a8.272,8.272,0,0,0,1.1-2.15,13.837,13.837,0,0,0,.55-2.43H63.2v-.94h3.98Zm-1.03,7.5v-3.38h-.89v3.38Zm3.75,1.16s.08.1.08.14-.06.1-.18.14a14.354,14.354,0,0,1-1.97.98l-.8-.76a6.573,6.573,0,0,0,2.16-1.03l.71.52Zm-.41-9.49c.17.01.26.05.26.12s-.07.16-.19.28v.38H71.4v-.85l.91.07c.17.01.25.05.25.12a.517.517,0,0,1-.18.28v.38h1.31v.94H72.38v1.55h-3.8v-1.55H67.37v-.94h1.21v-.85l.91.07Zm4.2,3.59v.89H67.38v-.89Zm-.28,1.26v3.98H67.8v-3.98Zm-3.38,1.5v-.65H68.78v.65Zm0,.85H68.78v.79h1.26Zm-.47-5.48v.65H71.4v-.65Zm1.45,4.63h1.42v-.65H71.02Zm1.42.85H71.02v.79h1.42Zm1.4,3-.94.61a8.449,8.449,0,0,0-1.79-1.22l.76-.61A11.328,11.328,0,0,1,73.84,161.44Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7667",
    "data-name": "Path 7667",
    d: "M81.14,151.21c.17.01.25.05.25.11s-.1.18-.29.32c-.01,1.34-.06,2.47-.16,3.38a6.979,6.979,0,0,0,.31,1.33,7.3,7.3,0,0,0,.88,1.96,5.86,5.86,0,0,0,1.64,1.75,5.79,5.79,0,0,0,2.06.91l-.89.98a7.9,7.9,0,0,1-2.1-1.31,8.087,8.087,0,0,1-1.58-1.91,8.779,8.779,0,0,1-.74-1.64,7.553,7.553,0,0,1-1.4,2.52,11.135,11.135,0,0,1-2.89,2.34l-1.03-.89a9.185,9.185,0,0,0,3.06-2.2,6.345,6.345,0,0,0,1.38-2.81,25,25,0,0,0,.34-4.99l1.16.13Zm-3.24,2.66c.1.02.16.07.16.17s-.08.2-.23.32a12.108,12.108,0,0,1-1.13,2.81l-1.08-.37a5.793,5.793,0,0,0,.66-1.26,10.625,10.625,0,0,0,.56-1.97l1.06.3Zm7.33.12c.14.05.23.11.23.18s-.1.17-.28.29a23.384,23.384,0,0,1-1.31,2.71l-.98-.28c.25-.53.46-1.01.62-1.44a18.981,18.981,0,0,0,.64-1.88l1.08.42Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7668",
    "data-name": "Path 7668",
    d: "M88.66,152.91v-1.92l1.12.13c.12.02.19.07.19.14s-.1.18-.28.29v1.36H91v.94H89.69v2.37c.46-.23.9-.47,1.36-.73v1.03l-1.36.77v3.35a1.354,1.354,0,0,1-.35,1.02,2.1,2.1,0,0,1-1.48.35l-.42-1.03h.77c.28,0,.42-.17.44-.52v-2.59l-.84.48c-.12.25-.24.37-.34.37-.07,0-.12-.06-.17-.19l-.38-1.07c.58-.22,1.15-.46,1.73-.73v-2.88h-1.6v-.94h1.6Zm5.2-.34v-1.54l.95.07c.17.02.26.07.26.16q0,.075-.18.24v1.07h1.73a6.915,6.915,0,0,0-1.13-.98l.66-.6a8.437,8.437,0,0,1,1.27,1.03l-.6.55h.83v.9H94.89v.79h2.57v6.8a.869.869,0,0,1-.64.9,3.231,3.231,0,0,1-1,.17l-.37-.98h.72a.345.345,0,0,0,.3-.37v-1.17H94.89v2.4H93.86v-2.4h-1.5v2.48h-.98v-7.82h2.48v-.79H91.23v-.9h2.63Zm0,3.9V155.2h-1.5v1.27Zm0,2.24v-1.36h-1.5v1.36Zm1.03-2.24h1.58V155.2H94.89Zm0,2.24h1.58v-1.36H94.89Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7669",
    "data-name": "Path 7669",
    d: "M104.21,151.35c.13.06.2.13.2.2s-.12.13-.34.18l-.19.19h2.11l.29-.14a.421.421,0,0,1,.26.1l.56.36a.224.224,0,0,1,.11.16c0,.1-.08.19-.24.28L105.46,154h3.25v4.96h-7.87v-4.54c-.35.22-.72.44-1.13.66l-.89-.8a11.393,11.393,0,0,0,2.45-1.39,14.242,14.242,0,0,0,2-1.88l.92.36Zm-2.62,8.35a8.97,8.97,0,0,1-1.4,2.25l-1.13-.38a7.98,7.98,0,0,0,1.5-2.1l1.03.23Zm2.57-5.71,1.13-1.18h-2.34c-.28.25-.54.48-.78.68a6.479,6.479,0,0,1-.67.49h2.66Zm.01,1.92v-.94h-2.24v.94Zm0,.93h-2.24v1.13h2.24Zm-.32,3c-.02.79-.05,1.5-.1,2.16l-1.22-.1a11.933,11.933,0,0,0,.34-2.11Zm1.35-3.93h2.43v-.94H105.2Zm2.44.93h-2.43v1.13h2.43Zm-.75,4.87-1.13.29a10.545,10.545,0,0,0-.52-2.11l.94-.24a9.724,9.724,0,0,1,.71,2.06Zm3.23-.42-.94.61a9.854,9.854,0,0,0-1.45-1.97l.74-.61a12.13,12.13,0,0,1,1.64,1.97Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7670",
    "data-name": "Path 7670",
    d: "M117.12,158.01a11.786,11.786,0,0,0-2.16-2.29l.7-.78a16.316,16.316,0,0,1,2.3,2.33l-.84.74Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7671",
    "data-name": "Path 7671",
    d: "M126.22,152.7c-.35.14-.73.28-1.14.4v.94h1.55v.89h-1.55v1.16h1.55v.9h-1.55v1.21h2.11v-2.53l.84.07q.24.015.24.12c0,.05-.07.13-.19.23v2.11h.56v-3.37h-1.45v-3.66l.88.07c.17.01.25.05.25.12,0,.05-.07.13-.19.23v.52h1.5v.85h-1.5v.89h1.45v4.35h2.21v-1.21h-1.55v-.9h1.55v-1.16h-1.55v-.89h1.55v-1.13h-1.45v-.98h2.53v6.27h.94v.98h-7.39l.72.54a.259.259,0,0,1,.11.17c0,.06-.08.11-.24.14a14.619,14.619,0,0,1-2.9,1.87l-.89-.89a8.3,8.3,0,0,0,3.09-1.83h-3.19v-.98h.89v-6.27l.77.36c.16-.04.3-.08.44-.13a2.714,2.714,0,0,0,.8-.47l.7.71a.352.352,0,0,1,.11.23.09.09,0,0,1-.1.1l-.28-.07a.649.649,0,0,0-.23.06Zm7.62,8.5-.98.76a15.919,15.919,0,0,1-2.9-2.21l.79-.52a12.162,12.162,0,0,0,3.09,1.97Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7672",
    "data-name": "Path 7672",
    d: "M140.21,151.35c.13.06.2.13.2.2s-.12.13-.34.18l-.19.19h2.11l.29-.14a.421.421,0,0,1,.26.1l.56.36a.224.224,0,0,1,.11.16c0,.1-.08.19-.24.28L141.46,154h3.25v4.96h-7.87v-4.54c-.35.22-.72.44-1.13.66l-.89-.8a11.393,11.393,0,0,0,2.45-1.39,14.242,14.242,0,0,0,2-1.88l.92.36Zm-2.62,8.35a8.97,8.97,0,0,1-1.4,2.25l-1.13-.38a7.98,7.98,0,0,0,1.5-2.1l1.03.23Zm2.57-5.71,1.13-1.18h-2.34c-.28.25-.54.48-.78.68a6.479,6.479,0,0,1-.67.49h2.66Zm.01,1.92v-.94h-2.24v.94Zm0,.93h-2.24v1.13h2.24Zm-.32,3c-.02.79-.05,1.5-.1,2.16l-1.22-.1a11.933,11.933,0,0,0,.34-2.11l.98.05Zm1.35-3.93h2.43v-.94H141.2Zm2.44.93h-2.43v1.13h2.43Zm-.75,4.87-1.13.29a10.545,10.545,0,0,0-.52-2.11l.94-.24a9.724,9.724,0,0,1,.71,2.06Zm3.23-.42-.94.61a9.854,9.854,0,0,0-1.45-1.97l.74-.61a12.13,12.13,0,0,1,1.64,1.97Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7673",
    "data-name": "Path 7673",
    d: "M151.23,151.64v3.66h-1.08v1.69h1.27v.94h-1.27v1.94c.5-.13,1.01-.28,1.5-.44v.89c-.89.32-2.28.73-4.17,1.26-.07.12-.16.19-.23.19s-.12-.06-.13-.18l-.24-1.03c.17-.02.32-.05.47-.08v-3.9l.88.06q.24.015.24.12,0,.075-.18.24v3.31c.29-.05.56-.1.84-.17v-4.83h-1.64v-3.66h3.75Zm-1.03.93h-1.69v1.79h1.69Zm4.06-1.22c.11.02.17.08.17.16,0,.06-.08.16-.24.28-.05.13-.11.25-.16.37h2.57a.64.64,0,0,1,.17-.05l.14.11.43.48a.591.591,0,0,1,.08.22c0,.07-.12.17-.34.28a7.785,7.785,0,0,1-1.45,2.01l-.19.19a16.675,16.675,0,0,0,2.72,1.21l-1.03.85a12.259,12.259,0,0,1-2.48-1.43c-.12.08-.23.17-.35.24a14.084,14.084,0,0,1-2.23,1.09l-.74-.79a13.1,13.1,0,0,0,2.55-1.25,5.948,5.948,0,0,1-.9-1.26,10.261,10.261,0,0,1-.67.86l-.94-.66a8.042,8.042,0,0,0,2.01-3.19l.86.28Zm2.7,6.2v4.4h-1.03v-.71h-2.58v.71h-1.03v-4.4Zm-1.04,2.76v-1.82h-2.58v1.82Zm-1.3-5.55c.19-.18.37-.37.54-.56a11.623,11.623,0,0,0,.78-1.1h-2.36a1.418,1.418,0,0,1-.11.18,5.8,5.8,0,0,0,1.15,1.49Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7674",
    "data-name": "Path 7674",
    d: "M163.98,153.28v-2.11l1.07.08c.19.02.3.07.3.16,0,.06-.08.16-.24.28v1.59h4.55v1.03h-4.55v2.01h3v5.62h-1.13v-.76h-5.05v.76H160.8v-5.62h3.18v-2.01h-4.73v-1.03h4.73Zm3,6.88v-2.81h-5.05v2.81Z",
    fill: "#bea77e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7675",
    "data-name": "Path 7675",
    d: "M173.59,156.28v3.55a1.834,1.834,0,0,0,1.15.86,9.4,9.4,0,0,0,2.7.28c1.68,0,3.23-.05,4.63-.14l-.37,1.18h-4.26a11.191,11.191,0,0,1-2.52-.23,3.368,3.368,0,0,1-1.56-.77,1.757,1.757,0,0,1-.44-.53l-1.1,1.19c-.07.12-.13.19-.19.19a.175.175,0,0,1-.18-.16l-.61-.83a10.52,10.52,0,0,0,1.63-1.14v-2.52h-.84v-.94h1.97Zm.05-1.55-.7.76a15.223,15.223,0,0,0-1.98-1.27l.76-.74a11.009,11.009,0,0,1,1.92,1.26Zm.24-2.39-.71.74a11.216,11.216,0,0,0-1.69-1.16l.76-.76a9.622,9.622,0,0,1,1.64,1.17Zm3.51.2-.42.23h1.45l1.03-1.59.84.17c.14.02.23.08.23.17s-.08.2-.23.32l-.71.94h1.92v.89h-3.07l-.4.85h2.77v6h-1.03V160h-3.66v.52h-1.03v-6h1.82l.36-.85h-2.93v-.89h2c-.34-.42-.68-.84-1.07-1.26l.89-.43a18.87,18.87,0,0,1,1.22,1.46Zm2.39,3.59v-.79h-3.66v.79Zm0,1.55v-.74h-3.66v.74Zm0,1.45v-.65h-3.66v.65Z",
    fill: "#bea77e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1411",
    "data-name": "Rectangle 1411",
    width: 209,
    height: 80,
    transform: "translate(0 19.02)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1412",
    "data-name": "Rectangle 1412",
    width: 92.37,
    height: 80,
    transform: "translate(58.31 19.02)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 0.76,
    cy: 0.76,
    r: 0.76,
    transform: "translate(107.2 21.03)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7676",
    "data-name": "Path 7676",
    d: "M143.49,34.71H73.83L89.2,63.24h38.56Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7677",
    "data-name": "Path 7677",
    d: "M70.07,82.96,89.2,64.13h38.56l21.33,18.86Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1413",
    "data-name": "Rectangle 1413",
    width: 79.32,
    height: 12.12,
    transform: "translate(69.78 83.94)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1414",
    "data-name": "Rectangle 1414",
    width: 79.32,
    height: 11.66,
    rx: 2.24,
    transform: "translate(69.78 83.71)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1272",
    "data-name": "Group 1272"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1415",
    "data-name": "Rectangle 1415",
    width: 4.75,
    height: 8.45,
    transform: "translate(93.64 85.73)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1416",
    "data-name": "Rectangle 1416",
    width: 2.07,
    height: 7.4,
    transform: "translate(93.84 86.24)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1417",
    "data-name": "Rectangle 1417",
    width: 2.07,
    height: 7.4,
    transform: "translate(96.1 86.24)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    "data-name": "Group 1273"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1418",
    "data-name": "Rectangle 1418",
    width: 4.75,
    height: 8.45,
    transform: "translate(78.12 85.73)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1419",
    "data-name": "Rectangle 1419",
    width: 2.07,
    height: 7.4,
    transform: "translate(78.32 86.24)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    width: 2.07,
    height: 7.4,
    transform: "translate(80.57 86.24)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1274",
    "data-name": "Group 1274"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    width: 4.75,
    height: 4.95,
    transform: "translate(86.15 85.35)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1422",
    "data-name": "Rectangle 1422",
    width: 2.07,
    height: 4.54,
    transform: "translate(86.35 85.55)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1423",
    "data-name": "Rectangle 1423",
    width: 2.07,
    height: 4.54,
    transform: "translate(88.6 85.55)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1424",
    "data-name": "Rectangle 1424",
    width: 4.75,
    height: 8.45,
    transform: "translate(137.52 85.73)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    width: 2.07,
    height: 7.4,
    transform: "translate(137.71 86.24)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1426",
    "data-name": "Rectangle 1426",
    width: 2.07,
    height: 7.4,
    transform: "translate(139.97 86.24)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1427",
    "data-name": "Rectangle 1427",
    width: 4.75,
    height: 8.45,
    transform: "translate(122 85.73)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1428",
    "data-name": "Rectangle 1428",
    width: 2.07,
    height: 7.4,
    transform: "translate(122.19 86.24)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1429",
    "data-name": "Rectangle 1429",
    width: 2.07,
    height: 7.4,
    transform: "translate(124.45 86.24)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 4.75,
    height: 4.95,
    transform: "translate(130.02 85.35)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1431",
    "data-name": "Rectangle 1431",
    width: 2.07,
    height: 4.54,
    transform: "translate(130.22 85.55)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1432",
    "data-name": "Rectangle 1432",
    width: 2.07,
    height: 4.54,
    transform: "translate(132.48 85.55)",
    fill: "#d2dadf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7678",
    "data-name": "Path 7678",
    d: "M108.61,29.39l-.7-.57-.62.57V22.67l.66.6.66-.6Z",
    fill: "#e4f2f9",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7679",
    "data-name": "Path 7679",
    d: "M135.39,31.08V27.33c0-.14-.27-.25-.61-.25h-4.44c-.34,0-.61-.11-.61-.25H87.74c0,.14-.27.25-.61.25H82.69c-.34,0-.61.11-.61.25v3.75c0,.14-.27.25-.61.25H74.45c-.34,0-.61.11-.61.25v3.21c0,.14.27.25.61.25h68.59c.34,0,.61-.11.61-.25V31.58c0-.14-.27-.25-.61-.25h-7.02c-.34,0-.61-.11-.61-.25Z",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1433",
    "data-name": "Rectangle 1433",
    width: 4.75,
    height: 4.95,
    transform: "translate(87.95 27.67)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1434",
    "data-name": "Rectangle 1434",
    width: 2.07,
    height: 4.54,
    transform: "translate(88.15 27.87)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1435",
    "data-name": "Rectangle 1435",
    width: 2.07,
    height: 4.54,
    transform: "translate(90.4 27.87)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1280",
    "data-name": "Group 1280"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1436",
    "data-name": "Rectangle 1436",
    width: 4.75,
    height: 4.95,
    transform: "translate(96.64 27.67)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1437",
    "data-name": "Rectangle 1437",
    width: 2.07,
    height: 4.54,
    transform: "translate(96.84 27.87)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1438",
    "data-name": "Rectangle 1438",
    width: 2.07,
    height: 4.54,
    transform: "translate(99.09 27.87)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1439",
    "data-name": "Rectangle 1439",
    width: 4.75,
    height: 4.95,
    transform: "translate(114.77 27.67)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1440",
    "data-name": "Rectangle 1440",
    width: 2.07,
    height: 4.54,
    transform: "translate(114.97 27.87)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1441",
    "data-name": "Rectangle 1441",
    width: 2.07,
    height: 4.54,
    transform: "translate(117.23 27.87)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1442",
    "data-name": "Rectangle 1442",
    width: 4.75,
    height: 4.95,
    transform: "translate(123.53 27.67)",
    fill: "#96a998"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 2.07,
    height: 4.54,
    transform: "translate(123.72 27.87)",
    fill: "#d2dadf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1444",
    "data-name": "Rectangle 1444",
    width: 2.07,
    height: 4.54,
    transform: "translate(125.98 27.87)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    "data-name": "Group 1283"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 3.57,
    cy: 3.57,
    r: 3.57,
    transform: "translate(104.62 26.14)",
    fill: "#a4b4d4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 3.57,
    cy: 3.57,
    r: 3.57,
    transform: "translate(104.62 25.57)",
    fill: "#d2dadf"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1445",
    "data-name": "Rectangle 1445",
    width: 0.16,
    height: 3.04,
    rx: 0.08,
    transform: "translate(108.15 26.13)",
    fill: "#a4b4d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1446",
    "data-name": "Rectangle 1446",
    width: 0.16,
    height: 1.57,
    rx: 0.08,
    transform: "translate(109.594 28.272) rotate(47.69)",
    fill: "#a4b4d4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    "data-name": "Group 1288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7680",
    "data-name": "Path 7680",
    d: "M42.61,37.72v.87H38.53l1.54-1.95a20.41,20.41,0,0,0,1.29-1.7,1.264,1.264,0,0,0,.2-.56c0-.04.01-.08.01-.12a1.05,1.05,0,0,0-.27-.71.864.864,0,0,0-.69-.31.813.813,0,0,0-.68.35,1.467,1.467,0,0,0-.24.85H38.61a2.092,2.092,0,0,1,.54-1.48,1.869,1.869,0,0,1,1.45-.58,1.94,1.94,0,0,1,1.4.56,1.877,1.877,0,0,1,.57,1.4,4,4,0,0,1-1.21,2.2l-1.03,1.2h2.28Z",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7681",
    "data-name": "Path 7681",
    d: "M49.44,35.56a4.175,4.175,0,0,1-.58,2.26,1.8,1.8,0,0,1-1.59.93,1.777,1.777,0,0,1-1.59-.94,4.187,4.187,0,0,1-.58-2.25,4.246,4.246,0,0,1,.58-2.28,1.829,1.829,0,0,1,3.18.01,4.175,4.175,0,0,1,.58,2.26Zm-3.35,0a3.935,3.935,0,0,0,.32,1.62c.21.47.5.7.87.7a.933.933,0,0,0,.85-.66,4.057,4.057,0,0,0,.3-1.67,3.869,3.869,0,0,0-.32-1.62c-.21-.46-.5-.69-.85-.69s-.64.24-.85.72a3.926,3.926,0,0,0-.32,1.59Z",
    fill: "url(#radial-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7682",
    "data-name": "Path 7682",
    d: "M55.9,37.72v.87H51.82l1.54-1.95a20.41,20.41,0,0,0,1.29-1.7,1.264,1.264,0,0,0,.2-.56c0-.04.01-.08.01-.12a1.05,1.05,0,0,0-.27-.71.864.864,0,0,0-.69-.31.813.813,0,0,0-.68.35,1.467,1.467,0,0,0-.24.85H51.9a2.092,2.092,0,0,1,.54-1.48,1.869,1.869,0,0,1,1.45-.58,1.94,1.94,0,0,1,1.4.56,1.877,1.877,0,0,1,.57,1.4,4,4,0,0,1-1.21,2.2l-1.03,1.2H55.9Z",
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7683",
    "data-name": "Path 7683",
    d: "M62.69,36.65v.79h-.72v1.15h-.95V37.44H58.26v-.45l2.71-4.58h1v4.24Zm-1.67-2.79-1.56,2.8h1.56Z",
    fill: "url(#radial-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7684",
    "data-name": "Path 7684",
    d: "M14.42,53.09a10.447,10.447,0,0,0,4.58.88,9.172,9.172,0,0,0,4.55-1.02,6.808,6.808,0,0,0,2.79-2.86,10.092,10.092,0,0,0,.97-4.7,8.276,8.276,0,0,0-2.21-6.14,8.55,8.55,0,0,0-6.29-2.19,8.268,8.268,0,0,0-6.21,2.23,8.433,8.433,0,0,0-2.23,6.24,9.316,9.316,0,0,0,1.13,4.78,6.909,6.909,0,0,0,2.94,2.79Zm1.92-11.12a3.08,3.08,0,0,1,2.45-1.08,3.271,3.271,0,0,1,2.53,1.07,5.062,5.062,0,0,1,.93,3.37,6.058,6.058,0,0,1-.89,3.8,3.116,3.116,0,0,1-2.52,1.06,3.072,3.072,0,0,1-2.5-1.08,5.508,5.508,0,0,1-.92-3.56,5.508,5.508,0,0,1,.93-3.58Zm26.45,5.92a7.548,7.548,0,0,0-1.3-4.5,4.264,4.264,0,0,0-3.68-1.82,4.638,4.638,0,0,0-2.2.52,5.754,5.754,0,0,0-1.62,1.49V41.83H29.74V58.19h4.59V52.53a4.514,4.514,0,0,0,1.55,1.06,4.924,4.924,0,0,0,1.91.36,4.624,4.624,0,0,0,3.58-1.56,6.5,6.5,0,0,0,1.42-4.51Zm-5.08,2.02a1.642,1.642,0,0,1-1.33.65,1.894,1.894,0,0,1-1.49-.68,3.141,3.141,0,0,1-.59-2.09,3.363,3.363,0,0,1,.58-2.21,1.843,1.843,0,0,1,1.45-.68,1.7,1.7,0,0,1,1.36.68,3.286,3.286,0,0,1,.56,2.11,3.489,3.489,0,0,1-.54,2.21Zm9.81,3.38a8.539,8.539,0,0,0,3.7.66,8.946,8.946,0,0,0,4.16-.78,6.449,6.449,0,0,0,2.48-2.56l-4.47-.41a2.975,2.975,0,0,1-.79.75,2.615,2.615,0,0,1-1.27.33,2.163,2.163,0,0,1-1.72-.77,2.953,2.953,0,0,1-.59-1.63h9.1v-.51a8.17,8.17,0,0,0-.77-3.8,5.187,5.187,0,0,0-2.24-2.23,8.788,8.788,0,0,0-4.02-.77,6.74,6.74,0,0,0-4.91,1.72,5.958,5.958,0,0,0-1.78,4.5,6.407,6.407,0,0,0,.89,3.4,5.446,5.446,0,0,0,2.24,2.11Zm2.03-8.17a2.065,2.065,0,0,1,1.73-.86,2.036,2.036,0,0,1,1.51.57,3.068,3.068,0,0,1,.71,1.89H49.03a3.173,3.173,0,0,1,.52-1.6ZM64.75,48a3.629,3.629,0,0,1,.51-2.24,1.636,1.636,0,0,1,1.34-.62,1.471,1.471,0,0,1,1.16.46,2.341,2.341,0,0,1,.41,1.58V53.7h4.56V46.17a4.86,4.86,0,0,0-1.07-3.46,3.859,3.859,0,0,0-2.95-1.12,5.061,5.061,0,0,0-2.37.51,6.237,6.237,0,0,0-1.92,1.69V41.86H60.19V53.71h4.54V48.02ZM11.2,59.88a1.319,1.319,0,0,1,.78-.18,7.329,7.329,0,0,1,1.16.12l.44-2.42a28.549,28.549,0,0,0-3.06-.25,5.151,5.151,0,0,0-2,.3,2.572,2.572,0,0,0-1.06.79,2.917,2.917,0,0,0-.52,1.25A8.193,8.193,0,0,0,6.8,60.9v.47H5.3V64.3H6.8v7.52h4.02V64.3h1.91V61.37H10.82a5.589,5.589,0,0,1,.05-.92,1.127,1.127,0,0,1,.33-.58Zm8.14,1.26a6.053,6.053,0,0,0-4.36,1.55,5.21,5.21,0,0,0-1.61,3.94,5.134,5.134,0,0,0,1.91,4.15,6.216,6.216,0,0,0,4.07,1.28,6.084,6.084,0,0,0,4.42-1.54,5.685,5.685,0,0,0,.31-7.56,6,6,0,0,0-4.74-1.82Zm1.45,7.56a1.849,1.849,0,0,1-2.84-.01,3.158,3.158,0,0,1-.57-2.07,3.1,3.1,0,0,1,.57-2.05,1.806,1.806,0,0,1,1.45-.67,1.766,1.766,0,0,1,1.39.66,3.1,3.1,0,0,1,.56,2.02,3.28,3.28,0,0,1-.56,2.12Zm11.42-7.14a4.135,4.135,0,0,0-1.12,1.53V61.38H27.34V71.83h4.03v-3.5a6.62,6.62,0,0,1,.62-3.42,1.4,1.4,0,0,1,1.22-.65,3.068,3.068,0,0,1,1.12.3l1.24-2.85a4.2,4.2,0,0,0-1.94-.55,2.281,2.281,0,0,0-1.42.42ZM46.6,57.4l-2.91,4.87L40.78,57.4H35.83l5.62,8.39v6.04h4.47V65.79l5.61-8.39Zm7.67,3.74a6.053,6.053,0,0,0-4.36,1.55,5.209,5.209,0,0,0-1.61,3.94,5.134,5.134,0,0,0,1.91,4.15,6.216,6.216,0,0,0,4.07,1.28,6.084,6.084,0,0,0,4.42-1.54c1.07-1.03,1.6-3.49,1.6-5.1,0-1.43-.43-1.49-1.29-2.46a6,6,0,0,0-4.74-1.82Zm1.45,7.56a1.849,1.849,0,0,1-2.84-.01,3.158,3.158,0,0,1-.57-2.07,3.1,3.1,0,0,1,.57-2.05,1.806,1.806,0,0,1,1.45-.67,1.766,1.766,0,0,1,1.39.66,3.1,3.1,0,0,1,.56,2.02,3.28,3.28,0,0,1-.56,2.12Zm12.81-7.33V66.4a3.16,3.16,0,0,1-.46,1.98,1.45,1.45,0,0,1-1.18.55,1.3,1.3,0,0,1-1.02-.41,2.14,2.14,0,0,1-.36-1.4V61.37H61.48v6.65a4.286,4.286,0,0,0,.94,3.05,3.406,3.406,0,0,0,2.59.99,4.55,4.55,0,0,0,2.09-.44,5.536,5.536,0,0,0,1.69-1.49v1.69h3.74V61.37H68.52Z",
    fill: "url(#radial-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7685",
    "data-name": "Path 7685",
    d: "M7.07,34.13c2.87,1.32,8.31,1.31,13.49,2.77,4.15,1.17,5.53,2.74,5.62,7.29-.42-1.02-3.11.67-5.1-2.73-1.81-3.1-10.37-.1-14.25-2.82l2.33-1.63a8.764,8.764,0,0,0-2.1-2.87Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7686",
    "data-name": "Path 7686",
    d: "M22.06,55.74c-2.31.64-6.39-.02-10.45.44-3.25.37-4.61.87-4.82,4.16.44-.72,1.17,2.01,3.54.18,2.12-1.64,8.12.18,11.36-1.39l-1.55-1.5a6.769,6.769,0,0,1,1.92-1.9Z",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7687",
    "data-name": "Path 7687",
    d: "M97.01,65.23c.94,0,1.41.3,1.41.89-.03.47-.32.74-.86.79h-1.5v.76a1.3,1.3,0,0,1,.42-.09,6.215,6.215,0,0,1,1.94,1.05l-.99,1.7c-.53-.39-.98-.74-1.38-1.03v1.76H94.16c0-.69,0-1.29.02-1.82q-.63.705-1.29,1.5l-1.27-1.08a13.988,13.988,0,0,1,1.33-1.7,1.487,1.487,0,0,1,.92-.38,1.119,1.119,0,0,1,.32.09v-.73c-1.04.02-1.75.05-2.14.09V65.35c.41-.04,1.14-.07,2.17-.09v-.23c0-.57.31-.85.92-.85s.91.36.91,1.05H97Zm-2.23-8.14a.79.79,0,0,1,.38.09,9.63,9.63,0,0,1,1.44,1.14l-.38.42h.98c.89,0,1.33.28,1.33.85a.769.769,0,0,1-.79.77c-1.34,0-2.45,0-3.33.02a12.508,12.508,0,0,0,.47,1.94h.56c.06-.25.14-.56.23-.91a1.154,1.154,0,0,1,.98-.67.783.783,0,0,1,.83.79,4.386,4.386,0,0,1-.18.77h.02c.92,0,1.38.31,1.38.92-.02.47-.3.74-.83.79q-4.86,0-6.02.12V62.42q.4-.03,1.17-.06a6.237,6.237,0,0,1-.15-.73,12.359,12.359,0,0,1-.15-1.24c-.31.01-.56.02-.73.03V58.8c.43-.02,1.19-.04,2.27-.05a2.078,2.078,0,0,1-.21-.21,1.2,1.2,0,0,1-.26-.61c.04-.54.37-.82.98-.85Zm9.7.67c.64.03.95.27.95.73a.912.912,0,0,1-.73.92c-1.22.21-2.42.45-3.61.73-.03.54-.07,1.24-.12,2.12,1.45.04,2.7.12,3.73.23.55.13.83.4.86.8-.02.53-.35.81-.98.85a5.525,5.525,0,0,1-.58-.02c.06.41.16,1.38.29,2.89.15,2.07.23,3.41.23,4.03h-1.88q-.06-2.91-.21-4.38c-.07-.86-.14-1.58-.2-2.17a4.159,4.159,0,0,1-.06-.44c-.46-.02-.9-.05-1.3-.08q-.135,3.135-.17,6.58H98.94q0-4.065.36-11.41c.09-.63.39-.96.91-1.02a.909.909,0,0,1,.61.23,26.125,26.125,0,0,1,3.65-.61Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7688",
    "data-name": "Path 7688",
    d: "M110.24,61.15a3.368,3.368,0,0,1,.68.06c-.02-.57-.04-1.08-.05-1.55s-.03-.89-.03-1.24c0-.56.3-.83.89-.83.62.01.92.35.92,1.02.02.31.08,2.06.17,5.24q.12,5.28.12,6.82h-1.88c0-.6,0-1.17-.02-1.71a14.7,14.7,0,0,1-1.5.47,8.467,8.467,0,0,1-2.24.35V67.84a11.774,11.774,0,0,0,3.5-.91.525.525,0,0,1,.23-.06c-.02-1.43-.05-2.62-.08-3.56v-.23a.707.707,0,0,1-.12.02,23.343,23.343,0,0,0-3.39.14V61.3a23.233,23.233,0,0,1,2.79-.14Zm6.1-3.62a.769.769,0,0,1,.8.83c0,.06-.03.27-.08.62-.08.83-.16,1.62-.23,2.36.29.03.62.06.97.09,1.26.1,1.99.17,2.18.2a.984.984,0,0,1,.83,1.05c-.05.57-.41.86-1.08.89-.42,0-1.44-.08-3.05-.24-.07,1.22-.11,2.34-.11,3.35a2.992,2.992,0,0,0,.33,1.59,1.08,1.08,0,0,0,.94.45,8.369,8.369,0,0,0,2.95-.77v1.88a7.956,7.956,0,0,1-2.89.77h-.44a2.645,2.645,0,0,1-2.11-1.02,4.707,4.707,0,0,1-.67-2.8,62.568,62.568,0,0,1,.55-8.47.984.984,0,0,1,1.08-.79Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7689",
    "data-name": "Path 7689",
    d: "M123.87,57.53a.859.859,0,0,1,.74.33,8.755,8.755,0,0,1,2.26-.33,2.027,2.027,0,0,1,1.8.85,4.539,4.539,0,0,1,.64,2.38v.85a3.659,3.659,0,0,1-.65,2.59,3.216,3.216,0,0,1-2.02.65,15.811,15.811,0,0,1-1.71-.08q.09,4.875.09,6.39H123.2q-.03-5.1-.09-7.7c-.03-1.51-.06-2.77-.08-3.8-.01-.49-.02-.93-.02-1.3a.739.739,0,0,1,.85-.83Zm1.03,5.5q.84.09,1.56.12a1.284,1.284,0,0,0,.86-.27q.3-.21.3-1.44a3,3,0,0,0-.39-1.91,1.086,1.086,0,0,0-.85-.32,7.056,7.056,0,0,0-1.59.38c0,.25.02.54.03.86.22,0,.47-.02.74-.03.85,0,1.27.29,1.27.86-.03.43-.3.68-.8.73-.46,0-.85.01-1.15.03,0,.33,0,.66.02.98Zm4.9,1.33a.888.888,0,0,1,.92.92,2.951,2.951,0,0,1-.67,1.06c-.04.06-.08.11-.11.15a31.139,31.139,0,0,1,3.85,2.61l-.89,1.56q-2.19-1.485-3.95-2.67a19.739,19.739,0,0,0-1.44,2.99l-1.88-.42c1.64-3.4,2.73-5.29,3.27-5.65a1.092,1.092,0,0,1,.89-.55Zm1.21-7.15a.75.75,0,0,1,.61.27,8.223,8.223,0,0,1,2.06-.33h.44a2.723,2.723,0,0,1,1.74.55c.5.44.76,1.39.76,2.85s-.15,4.76-.45,9.7a.83.83,0,0,1-.95.74c-.54,0-.8-.29-.8-.86q.27-3.27.38-5.97a5.5,5.5,0,0,1-1.94.41h-.56a2.234,2.234,0,0,1-1.61-.92,3.6,3.6,0,0,1-.62-2.23q0-1.05.12-3.33c.06-.56.34-.84.83-.86Zm3.82,5.36q.03-1.035.03-1.95c0-1.17-.35-1.76-1.05-1.76a8,8,0,0,0-2.08.33c-.02.41-.04.77-.05,1.06q.66-.045,1.23-.09c.19-.02.35-.03.47-.03a.754.754,0,0,1,.79.73.838.838,0,0,1-.56.77,14.575,14.575,0,0,1-1.86.26c.16.72.55,1.08,1.15,1.08a5.431,5.431,0,0,0,1.92-.39Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7690",
    "data-name": "Path 7690",
    d: "M141.21,57.82c.47.02.73.31.77.86,0,.25-.05.91-.11,1.99a1.741,1.741,0,0,0,.12-.14,1.817,1.817,0,0,1,1.03-.58.66.66,0,0,1,.61.39l.12-.82a10.25,10.25,0,0,1,1.82.17c.37.1.57.3.59.61-.01.38-.25.59-.73.61a9.38,9.38,0,0,1-1.76-.15.92.92,0,0,1-.47.65c-.44.41-.92.85-1.42,1.32q-.03.63-.03,1.29h.53c.61.02.97.18,1.09.47a6.193,6.193,0,0,1,2.06-1.02c.46.01.74.16.83.44.36,0,.78-.02,1.26-.03q-.09-.1-.15-.18a.791.791,0,0,1-.23-.61c0-.04,0-.07.02-.08a1.5,1.5,0,0,1-.2.02c-.48,0-.73-.22-.73-.67a11.074,11.074,0,0,0,.29-2.21,2.831,2.831,0,0,0-.23-1.39.709.709,0,0,0-.59-.27,3.161,3.161,0,0,0-1.73.61l-.29-1.27a5.077,5.077,0,0,1,2.17-.67h.33a1.554,1.554,0,0,1,1.33.55,3.074,3.074,0,0,1,.52,1.88v.58a10.2,10.2,0,0,1-.24,2.27.873.873,0,0,1,.61.33,5.4,5.4,0,0,1,.77,1.09c.51,0,1.04-.02,1.61-.02.72,0,1.08.22,1.08.67a.663.663,0,0,1-.67.67h-1.88c-.01.12-.02.35-.03.68.47,0,.97-.02,1.5-.02.6,0,.89.2.89.61-.01.32-.19.5-.55.53h-1.91c-.01.24-.02.47-.03.68.5,0,1.06-.02,1.65-.02s.89.2.89.61a.536.536,0,0,1-.55.55c-.74,0-1.42,0-2.05.02-.01.24-.02.46-.02.67.59-.01,1.22-.02,1.89-.02.73,0,1.09.22,1.09.67a.651.651,0,0,1-.67.67q-4.2,0-5.82.12v.36h-1.53c-.01-1.68-.02-2.94-.03-3.79-.01-.65-.02-1.21-.02-1.68-.25.15-.5.3-.74.44l-.2-.86a1.429,1.429,0,0,1-.47.14h-.02c-.02.1-.05.21-.08.33a17.51,17.51,0,0,0-.58,2.71.548.548,0,0,0,.62.61,8.56,8.56,0,0,0,1.21-.26v1.33a5.66,5.66,0,0,1-1.45.32h-.23a1.568,1.568,0,0,1-1.15-.55,1.7,1.7,0,0,1-.38-1.17,14.392,14.392,0,0,1,.61-3.32c-.28,0-.53.02-.74.02a4.608,4.608,0,0,1-.18.74,34.144,34.144,0,0,0-.73,3.83l-1.39-.29c.36-2.1.63-3.51.8-4.23-.25,0-.5.02-.74.03v-1.5c.49-.04,1.16-.07,2-.09,0-.32,0-.66.02-1.02l-1.03.67a8.678,8.678,0,0,1-.98-2.89.731.731,0,0,1,.73-.79.77.77,0,0,1,.73.47,13.835,13.835,0,0,0,.59,1.61c.03-1,.08-2.14.15-3.41.08-.54.34-.82.79-.86Zm4.29,3.81a.557.557,0,0,1,.55.56.607.607,0,0,1-.35.55,7.155,7.155,0,0,1-1.94.41l-.26-1.14a8.229,8.229,0,0,0,1.68-.32A1.16,1.16,0,0,1,145.5,61.63Zm2.16,4.26c.01-.24.02-.47.03-.7-.93.02-1.66.05-2.2.08,0,.16.02.4.05.71.56-.04,1.26-.07,2.12-.09Zm-.04,1.79c0-.22.02-.45.02-.68-.87.04-1.56.08-2.08.12,0,.2.02.42.02.65.52-.03,1.21-.06,2.05-.09Zm-2,1.89c.49-.03,1.15-.06,1.95-.08.01-.22.02-.45.02-.68-.83.02-1.49.05-1.98.08,0,.25,0,.48.02.68Zm4.77-12.36a1.511,1.511,0,0,1,1.32.58,3.345,3.345,0,0,1,.53,1.94v.59a10.382,10.382,0,0,1-.32,2.59.744.744,0,0,1-.79.44c-.44,0-.67-.2-.67-.61a11.931,11.931,0,0,0,.32-2.42,2.884,2.884,0,0,0-.26-1.48.729.729,0,0,0-.62-.29,3.279,3.279,0,0,0-1.67.55l-.32-1.27a5.33,5.33,0,0,1,2.17-.61h.3Zm-1.97,2.2a5.988,5.988,0,0,1,1.56.23c.34.09.53.28.55.56-.01.33-.21.52-.61.55a6.59,6.59,0,0,1-1.68-.26Zm1.21,1.68c.6,0,.89.2.89.61a.536.536,0,0,1-.55.55,12.886,12.886,0,0,0-1.68.06V61.16a12.458,12.458,0,0,1,1.33-.06Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7691",
    "data-name": "Path 7691",
    d: "M158.6,58.6c.88,0,1.32.28,1.33.83.22-.23.44-.44.67-.64a1.2,1.2,0,0,1,.77-.32.628.628,0,0,1,.62.61,1.384,1.384,0,0,1-.32.73c-.54.58-1.08,1.15-1.62,1.73.77.03,1.15.3,1.15.82a.779.779,0,0,1-.79.79c-.7,0-1.32.01-1.88.03-.16.16-.31.31-.44.45a3.469,3.469,0,0,1,1.52.32,1.2,1.2,0,0,1,.73,1.14,3.42,3.42,0,0,1-.79,1.76.671.671,0,0,1-.24.26.265.265,0,0,1,.05.06.751.751,0,0,0,.26-.05,4.251,4.251,0,0,1,.98-.15.736.736,0,0,1,.73.74.818.818,0,0,1-.5.73,8.2,8.2,0,0,1-.97.26c0,.1.02.19.02.27a3.072,3.072,0,0,1-1.27,2.26l-1.27-.56a2.785,2.785,0,0,0,1.02-1.71c-.95.14-2.1.27-3.44.38l-.24-1.56c1.02-.08,1.97-.18,2.86-.3-.06-.06-.12-.12-.18-.17-.26-.21-.39-.4-.39-.58.04-.42.3-.64.79-.65a1.386,1.386,0,0,1,.71.2,2.177,2.177,0,0,0,.38-.86c0-.25-.27-.38-.8-.38a5.267,5.267,0,0,0-1.45.27c-.6.66-1.19,1.32-1.79,1.98l-1.11-.92c.89-1.12,1.77-2.17,2.65-3.15-1.2.03-2.03.08-2.47.14V61.71c.44-.05,1.17-.09,2.18-.12-.04-.49-.08-.92-.11-1.3-.82,0-1.38.02-1.7.03V58.7c.32,0,.84-.02,1.56-.03-.03-.35-.05-.61-.06-.77.02-.51.24-.77.67-.79a.939.939,0,0,1,1.05.85c.01.23.03.46.05.68.34,0,.71-.02,1.11-.02Zm-.74,2.94q.615-.66,1.23-1.29h-1.48q.045.63.09,1.29h.17Zm8.02,1.02a.768.768,0,0,1,.77.79,1.377,1.377,0,0,1-.17.61,22.156,22.156,0,0,0-1.52,2.8c1.11.66,2.08,1.28,2.89,1.86l-.77,1.62c-.89-.68-1.83-1.32-2.83-1.94a26.131,26.131,0,0,0-1.11,2.86l-1.71-.5c.51-1.23.96-2.3,1.36-3.21-.37-.2-.75-.4-1.12-.61a1.091,1.091,0,0,1-.59-.77c.02-.55.28-.83.79-.85a1.873,1.873,0,0,1,.61.12c.35.18.69.37,1,.56a25.912,25.912,0,0,1,1.41-2.76,1.132,1.132,0,0,1,.99-.59Zm-2.19-5.15a.72.72,0,0,1,.79.73,4.382,4.382,0,0,1-.36,1.18c-.03.08-.06.16-.08.23,1.05.03,2.01.08,2.86.15a.991.991,0,0,1,.79,1.05.755.755,0,0,1-.73.73,6.842,6.842,0,0,1-.95-.11c-.6-.07-1.42-.13-2.48-.18-.27,1.02-.53,2.13-.76,3.32l-1.56-.36a38.15,38.15,0,0,1,1.74-6.32.96.96,0,0,1,.74-.41Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7692",
    "data-name": "Path 7692",
    d: "M181.88,58.32c.76.01,1.16.27,1.21.77a.847.847,0,0,1-.86.86c-.55,0-1.07,0-1.58.02.06.05.12.1.17.15a11.764,11.764,0,0,1,1.89,2.44l-1.27,1.02c-.36-.46-.69-.87-.98-1.23a23.036,23.036,0,0,1-3.33.86,19.237,19.237,0,0,1-3.33.49h-.42a3.172,3.172,0,0,1-2.15-.62,1.818,1.818,0,0,1-.62-1.45,4.626,4.626,0,0,1,.33-1.39l-1.35.03V58.62c1.31-.08,3.07-.15,5.26-.2a1.047,1.047,0,0,1-.36-.65c.03-.54.34-.81.92-.83.47.01,1.18.49,2.11,1.44,1.34-.02,2.8-.04,4.38-.05Zm-3.65,5.38a6.512,6.512,0,0,1,3.06.53c.83.3,1.26,1.17,1.29,2.59v.27a12.55,12.55,0,0,1-.52,3.35.953.953,0,0,1-.99.73c-.61,0-.91-.26-.91-.79a11.024,11.024,0,0,0,.53-3.14c0-.93-.25-1.54-.74-1.8a8.207,8.207,0,0,0-1.95-.21,30.635,30.635,0,0,0-5.97.74c.02.21.04.46.06.74q1.95-.255,6.09-.35c.77,0,1.15.25,1.15.74a.676.676,0,0,1-.67.67,54.759,54.759,0,0,0-6.52.27c0,.31.02.59.03.83q1.845-.165,6-.21c.77,0,1.15.24,1.15.73a.651.651,0,0,1-.67.67q-4.59,0-6.44.18c0,.43.02.76.02.98h-1.88c-.02-1.66-.05-2.9-.09-3.73-.03-.73-.06-1.34-.08-1.85-.01-.23-.02-.44-.02-.62,0-.57.3-.85.89-.85a.856.856,0,0,1,.7.3,26.673,26.673,0,0,1,5.55-.79h.91Zm.87-2.72a1.047,1.047,0,0,1-.27-.73.674.674,0,0,1,.06-.27q-3.57.045-5.73.15c-.14.01-.28.02-.42.02a8.738,8.738,0,0,1-.38,1.12c0,.49.4.74,1.2.74a12.1,12.1,0,0,0,2.48-.33c.81-.14,1.83-.37,3.06-.7Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7693",
    "data-name": "Path 7693",
    d: "M196.06,57.27a.877.877,0,0,1,.95.86.842.842,0,0,1-.77.83c-.67.07-1.94.16-3.83.27.01.33.02.66.03.98,1.47-.04,3.11-.07,4.89-.09.8.02,1.22.3,1.27.83a.833.833,0,0,1-.86.85c-.27,0-.54,0-.79.02a25.264,25.264,0,0,1,1.65,2.24l-1.65,1.02a21.48,21.48,0,0,0-2.33-3.23c-.77.03-1.48.06-2.14.08.01.33.02.67.03,1a5.209,5.209,0,0,1,1.98.53,2.015,2.015,0,0,1,1.18,1.85,1.918,1.918,0,0,1-.68,1.27c.78,0,1.58-.02,2.39-.03.81.02,1.23.3,1.27.83a.833.833,0,0,1-.86.85c-1.36.01-2.61.03-3.73.05a5.163,5.163,0,0,1,.05.67,2.251,2.251,0,0,1-.59,1.82,2.692,2.692,0,0,1-1.85.56,4.448,4.448,0,0,1-2.3-.61l.32-1.56a2.571,2.571,0,0,0,1.42.48c.24-.02.45-.05.64-.08a.871.871,0,0,0,.36-.14c.16-.11.24-.35.24-.73-.01-.12-.03-.24-.05-.36-1.53.04-2.8.09-3.82.15-1.29.09-2.54.15-3.73.17v-1.7c1.65-.14,3.95-.25,6.92-.32V66.6a.9.9,0,0,1,.83-.92.877.877,0,0,1,.79.38,1.7,1.7,0,0,0,.42-.64c0-.55-.75-.82-2.24-.82a12.054,12.054,0,0,0-4.06,1.21l-.21-1.56a14.652,14.652,0,0,0-.86,1.56l-1.59-1.15c.59-.99,1.07-1.8,1.45-2.42-.43.02-.86.04-1.27.05V60.61c1.37-.15,3.22-.27,5.55-.35-.01-.39-.02-.7-.03-.91-1.37.06-2.83.1-4.36.11V57.75q4.98-.09,9.09-.44c.3-.03.59-.05.86-.05Zm-8.71,6.8a12.9,12.9,0,0,1,3.21-1.05c-.01-.37-.02-.71-.02-1.02-.71.03-1.33.07-1.88.11l-.15.21c-.45.64-.83,1.22-1.17,1.74Z",
    fill: "#f9f6c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7694",
    "data-name": "Path 7694",
    d: "M95.78,48.61a2.1,2.1,0,0,0-.57-.63,3.057,3.057,0,0,0-.86-.45,6.545,6.545,0,0,0-.99-.26,8.049,8.049,0,0,1-2.87-1,.682.682,0,0,1-.24-.26.668.668,0,0,1-.13-.38,4.239,4.239,0,0,1,.22-1.35,2.876,2.876,0,0,1,.58-1.06,4.71,4.71,0,0,1,2.03-1.11,10.609,10.609,0,0,1,3.3-.47,6.733,6.733,0,0,1,1.7.17c.4.11.6.28.6.52a1.893,1.893,0,0,1-.16.88,1.085,1.085,0,0,1-.34.42,5.552,5.552,0,0,1-.63.28,6.1,6.1,0,0,0-.83.35,6.276,6.276,0,0,0-.61.35,1.082,1.082,0,0,1-.31.17c-.05,0-.08-.02-.08-.06q0-.135.27-.39a2.4,2.4,0,0,1,.67-.46c.28-.15.42-.24.42-.28,0-.07-.16-.1-.46-.1a12.57,12.57,0,0,0-2.61.25,6.433,6.433,0,0,0-1.89.66q-.69.405-.69.84a.4.4,0,0,0,.29.38c.19.07.61.2,1.26.37a12.778,12.778,0,0,1,1.75.59,5.689,5.689,0,0,1,1.64.98,1.527,1.527,0,0,1,.53,1.14,1.986,1.986,0,0,1-.21.87,2.546,2.546,0,0,1-.61.8,3.712,3.712,0,0,1-.93.6,7.217,7.217,0,0,1-1.13.36,12.266,12.266,0,0,1-1.48.26,13.669,13.669,0,0,1-1.52.1,7.452,7.452,0,0,1-2.15-.25c-.54-.17-.81-.42-.81-.76a1.72,1.72,0,0,1,.27-.71,1.451,1.451,0,0,1,.65-.65,1.92,1.92,0,0,1,.63-.15c.2-.01.3.01.3.07a.055.055,0,0,1-.02.05.176.176,0,0,1-.05.04l-.06.03c-.1.04-.18.07-.25.1a1.074,1.074,0,0,0-.15.07.1.1,0,0,0-.06.1c0,.11.53.16,1.58.16a19.889,19.889,0,0,0,2.25-.1,6.663,6.663,0,0,0,1.55-.36,4.179,4.179,0,0,0,1.22-.72Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7695",
    "data-name": "Path 7695",
    d: "M103.68,48.41v.48c-.44.45-.82.82-1.15,1.11a5.516,5.516,0,0,1-.85.65,1.226,1.226,0,0,1-.61.22c-.4,0-.59-.23-.59-.7a2.979,2.979,0,0,1,.37-1.31,15.127,15.127,0,0,1,1.06-1.75,4.64,4.64,0,0,0-.65.44,5.365,5.365,0,0,0-.54.52c-.16.18-.29.33-.4.46-.33.37-.65.75-.95,1.14s-.51.64-.62.76a.446.446,0,0,1-.3.18c-.4,0-.59-.49-.59-1.46A4.76,4.76,0,0,1,98,48.09a5.216,5.216,0,0,1,.78-1.53q1.335-2,2.28-3.27a21.053,21.053,0,0,1,1.57-1.92c.42-.43.7-.65.84-.64a1.17,1.17,0,0,1,.43.11c.11.06.16.12.16.19a1.543,1.543,0,0,1-.26.63c-.18.29-.48.75-.9,1.37-.46.66-.79,1.12-.98,1.38s-.48.65-.87,1.14-.73.93-1.05,1.31-.68.8-1.09,1.25v.91q1.02-1.14,1.77-1.86a10.913,10.913,0,0,1,1.27-1.09,1.608,1.608,0,0,1,.76-.37.566.566,0,0,1,.43.27.778.778,0,0,1,.2.45.406.406,0,0,1-.08.19c-.37.44-.66.8-.87,1.09a6.529,6.529,0,0,0-.5.77,1.307,1.307,0,0,0-.18.58c0,.24.11.36.34.36a4.3,4.3,0,0,0,1.62-.98Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7696",
    "data-name": "Path 7696",
    d: "M107.32,48.41v.56a7.7,7.7,0,0,1-1.38,1.44,1.9,1.9,0,0,1-1.09.48.981.981,0,0,1-.93-.66,3.4,3.4,0,0,1-.31-1.43,2.622,2.622,0,0,1,.06-.57,2.689,2.689,0,0,1,.14-.45c.06-.12.16-.3.31-.55q1.08-1.68,1.98-1.68c.31,0,.47.12.47.36a1.789,1.789,0,0,1-.3.76,3.21,3.21,0,0,1-.54.74c-.44.43-.73.72-.87.89a.864.864,0,0,0-.2.57.588.588,0,0,0,.21.46.792.792,0,0,0,.53.18,1.6,1.6,0,0,0,.79-.26,11.063,11.063,0,0,0,1.12-.84ZM106.81,45a.562.562,0,0,1-.36-.14.465.465,0,0,1-.17-.37,1.319,1.319,0,0,1,.32-.75.873.873,0,0,1,.66-.41.556.556,0,0,1,.38.14.529.529,0,0,1,.15.41,1.176,1.176,0,0,1-.31.72.887.887,0,0,1-.67.4Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7697",
    "data-name": "Path 7697",
    d: "M112.39,47.03c-.89,1-1.34,1.69-1.34,2.08q0,.33.27.33a1.208,1.208,0,0,0,.58-.23,13.852,13.852,0,0,0,1.11-.83v.53c-.72.71-1.28,1.22-1.66,1.54a1.652,1.652,0,0,1-.95.47c-.42,0-.63-.27-.63-.82a1.609,1.609,0,0,1,.08-.48,2.889,2.889,0,0,1,.21-.49c.09-.17.22-.41.41-.73s.39-.68.63-1.08a4.876,4.876,0,0,0-1.09.88,7.135,7.135,0,0,0-.72.78c-.19.25-.41.52-.64.82a5.816,5.816,0,0,1-.5.61.49.49,0,0,1-.32.16q-.24,0-.45-.51a3.122,3.122,0,0,1-.21-1.19,1.7,1.7,0,0,1,.1-.66,3.93,3.93,0,0,1,.38-.67,7.46,7.46,0,0,1,.91-1.19,1.088,1.088,0,0,1,.73-.38.87.87,0,0,1,.39.08.279.279,0,0,1,.15.26.367.367,0,0,1-.05.16.561.561,0,0,1-.1.15q-.06.06-.24.27c-.8.89-1.2,1.47-1.2,1.73,0,.15.05.22.14.22.06,0,.18-.1.35-.29s.4-.45.68-.77a11.335,11.335,0,0,1,.98-.99,11.526,11.526,0,0,1,1.29-1,1.245,1.245,0,0,1,.67-.28c.08,0,.16.11.24.34a1.989,1.989,0,0,1,.12.68q0,.165-.33.51Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7698",
    "data-name": "Path 7698",
    d: "M114.18,48.69v.19a1.014,1.014,0,0,0,.22.7.729.729,0,0,0,.58.25,1.874,1.874,0,0,0,.77-.18,4.686,4.686,0,0,0,.8-.46c.26-.19.59-.45.97-.78v.46a9.18,9.18,0,0,1-1.62,1.59,2.543,2.543,0,0,1-1.53.55,1.3,1.3,0,0,1-1.08-.53,2.368,2.368,0,0,1-.4-1.44,2.845,2.845,0,0,1,.37-1.45,5.851,5.851,0,0,1,1.22-1.38,4.9,4.9,0,0,1,1.15-.75,2.527,2.527,0,0,1,1.02-.25.9.9,0,0,1,.57.16.581.581,0,0,1,.21.49,1.6,1.6,0,0,1-.36.96,4.233,4.233,0,0,1-1.09.95,11.283,11.283,0,0,1-1.81.9Zm.07-.5a4.361,4.361,0,0,0,1.17-.66,3.116,3.116,0,0,0,.72-.76,1.244,1.244,0,0,0,.23-.53c0-.11-.05-.18-.16-.18a1.117,1.117,0,0,0-.45.18,4.006,4.006,0,0,0-.63.46,3.66,3.66,0,0,0-.57.66,2.07,2.07,0,0,0-.33.83Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7699",
    "data-name": "Path 7699",
    d: "M125.41,48.71l-1.36,1.15c-.65.56-1.08.85-1.3.85-.2,0-.41-.23-.63-.68a2.791,2.791,0,0,1-.33-1.19,1.848,1.848,0,0,1,.13-.74,5.261,5.261,0,0,1,.46-.78,11.383,11.383,0,0,1,.89-1.1,7.353,7.353,0,0,1,.75-.7.984.984,0,0,1,.46-.25.549.549,0,0,1,.4.21.641.641,0,0,1,.19.44,1,1,0,0,1-.21.46,7.407,7.407,0,0,1-.66.81,14.186,14.186,0,0,1-1.26,1.18l-.15.42a.483.483,0,0,0-.06.21.186.186,0,0,0,.21.21,2.841,2.841,0,0,0,1-.54,12.154,12.154,0,0,0,1.71-1.46c.24-.24.44-.45.59-.63s.3-.35.43-.51a3.27,3.27,0,0,1,.32-.36.434.434,0,0,1,.22-.13.282.282,0,0,1,.3.16,1.09,1.09,0,0,1,.11.54,1.046,1.046,0,0,1-.18.51q-.18.315-.69,1.05c-.34.5-.67,1.01-1,1.54s-.67,1.13-1.02,1.8c.02-.02.17-.17.47-.46l.94-.91c.33-.32.6-.57.82-.76s.48-.41.8-.67v.51q-1.035,1.11-1.86,2.1t-1.29,1.59c-.3.4-.48.63-.53.69-.14.18-.26.34-.37.5s-.2.27-.27.36-.13.13-.18.13c-.11,0-.2-.11-.29-.32a1.445,1.445,0,0,1-.13-.56.935.935,0,0,1,.08-.39,44.478,44.478,0,0,1,2.46-4.29Z",
    fill: "#f9f6c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7700",
    "data-name": "Path 7700",
    d: "M132.66,48.4v.51a4.1,4.1,0,0,1-.81.61,1.85,1.85,0,0,1-.88.12c-.66.78-1.24,1.17-1.75,1.17a1.226,1.226,0,0,1-.78-.28,1.879,1.879,0,0,1-.56-.77,2.751,2.751,0,0,1-.21-1.09,2.316,2.316,0,0,1,.32-1.08,4.921,4.921,0,0,1,.84-1.11,4.751,4.751,0,0,1,1.1-.83,2.319,2.319,0,0,1,1.09-.32,1.207,1.207,0,0,1,.56.11.34.34,0,0,1,.21.31.56.56,0,0,1-.18.35.683.683,0,0,1,.4.2.894.894,0,0,1,.11.51,3.419,3.419,0,0,1-.17.92,4.251,4.251,0,0,1-.47,1.04l.14.14h.11a.616.616,0,0,0,.26-.06,1.761,1.761,0,0,0,.23-.14c.07-.05.21-.16.43-.32Zm-1.57-2.01q-.63.375-1.08.69a4.987,4.987,0,0,0-.76.63,1.61,1.61,0,0,0-.42.64c-.13.57-.19.88-.19.92,0,.34.23.5.7.5a2.481,2.481,0,0,0,1.1-.56,1.952,1.952,0,0,1-.13-.69,2.682,2.682,0,0,1,.2-.98,7.908,7.908,0,0,1,.59-1.15Z",
    fill: "#f9f6c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    "data-name": "Group 1298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7701",
    "data-name": "Path 7701",
    d: "M116.74,82.78c-.07.06-.12.11-.19.17-.02-.02-.06-.03-.06-.06a2.516,2.516,0,0,0-.13-.47c-.04-.09-.16-.16-.24-.23a1.365,1.365,0,0,0-.13.31,1.28,1.28,0,0,0,.05.39c-.13-.1-.21-.16-.35-.27a.878.878,0,0,0,.1.23.791.791,0,0,1,.21.79.412.412,0,0,0,.09.33c.53.59,1.06,1.18,1.61,1.76a.692.692,0,0,1,.2.78,4.263,4.263,0,0,1-.91,1.75.213.213,0,0,0-.05.21.467.467,0,0,1-.02.54c-.04.07.01.22.07.31a.9.9,0,0,0,.27.2.506.506,0,0,1,.23.55c-.06.62-.06,1.25-.08,1.87V92a4.206,4.206,0,0,0,.1,1.9,2.931,2.931,0,0,1-.12.76c-.02.14-.01.28-.02.42.17,0,.41.07.5,0a1.049,1.049,0,0,0,.34-.58c.08-.51.1-1.03.14-1.55.05-.58.07-1.16.14-1.74a2.919,2.919,0,0,1,.29-.74.41.41,0,0,1,.11.01,1.508,1.508,0,0,1,.12.26c.35,1.1.71,2.19,1.05,3.29a1.941,1.941,0,0,1,.04.54.79.79,0,0,0,.72.71c.33,0,.41-.12.25-.39-.07-.13-.17-.24-.23-.37-.03-.06.01-.14.1-.23-.04-.08-.13-.16-.12-.24.12-1.25-.48-2.4-.58-3.72.11.18.17.28.23.38h.12c.18-.46.38-.91.53-1.38a9.149,9.149,0,0,0,.22-1.04c.03-.18.11-.24.31-.18.47.16.95.29,1.42.44.09.03.16.11.24.13.11.03.27.09.35.04.25-.13.48-.3.74-.46-.06-.09-.11-.17-.17-.25a.235.235,0,0,1-.02.08,3.3,3.3,0,0,1-.85-.2c-.51-.25-1-.57-1.49-.86a.381.381,0,0,1-.14-.19c-.15-.7-.15-.7-.73-1.12a8.523,8.523,0,0,1,.71-.65.618.618,0,0,0,.2-.86,1.17,1.17,0,0,0-1.13-.47.626.626,0,0,0-.51.67,1.47,1.47,0,0,1-.18.56c-.01.03-.19.04-.24,0a.8.8,0,0,0-.7-.16.981.981,0,0,1-.9-.26c-.21-.2-.52-.31-.75-.5a4.847,4.847,0,0,1-.71-.8c-.08-.11-.04-.3-.05-.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7702",
    "data-name": "Path 7702",
    d: "M107.94,85.99c.3-.03.52-.05.74-.07a.381.381,0,0,0,.03.1c-.05.09-.1.17-.17.29a2,2,0,0,0,.27-.02c-.55.31-1.03.96-1.75.35-.11-.1-.2-.22-.32-.34a2.108,2.108,0,0,0-.16,1.41c.06.53.19,1.05.29,1.57.03.16.03.33.07.49.06.27.1.5-.27.57-.07.01-.13.16-.15.26-.04.29-.04.59-.08.88-.12.75-.23,1.51-.39,2.25a1.715,1.715,0,0,0,.31,1.14c.09.21.12.36-.03.49a.53.53,0,0,1-.43.13.856.856,0,0,1-.38-.33,4.231,4.231,0,0,0-.24-.4,5.049,5.049,0,0,1-.06.56.387.387,0,0,1-.54.31c-.25-.07-.33-.26-.24-.54.07-.23.3-.46.06-.72.27-.6-.22-1.09-.23-1.65s-.06-1.13-.1-1.7c-.02-.27-.02-.56-.41-.61-.06,0-.14-.19-.13-.28.07-.77.17-1.54.24-2.31a8.024,8.024,0,0,0,0-.85c-.11.08-.18.14-.26.19a.661.661,0,0,1-.82.01,4.633,4.633,0,0,0-.71-.38c.19-.17.39-.34.62-.55.08.12.14.2.2.29h.1c.04-.16.1-.31.13-.47.08-.55.16-1.1.22-1.66.02-.22.16-.3.34-.39a8.511,8.511,0,0,0,.89-.5c.19-.12.09-.26-.04-.37-.39-.33-.21-.72-.1-1.09a.619.619,0,0,1,.7-.51.57.57,0,0,1,.35.14,1.1,1.1,0,0,1,.17,1.46.34.34,0,0,0-.06.27c.02.05.16.06.24.08.05.01.13,0,.16.02.42.37,1.04.53,1.2,1.17a2.967,2.967,0,0,0,.77,1.31Zm-2.81,8.48h.11a2.388,2.388,0,0,0,.21-.6c.05-.73.06-1.45.07-2.18a8.056,8.056,0,0,0-.06-.98c0-.08-.11-.15-.16-.23-.05.08-.11.16-.16.24v.06c-.04.95-.09,1.9-.11,2.84a7.981,7.981,0,0,0,.09.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7703",
    "data-name": "Path 7703",
    d: "M95.45,80.24h1.71V95.08h-.82s-.62-13.63-.89-14.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7704",
    "data-name": "Path 7704",
    d: "M123.93,80.24h-1.71V95.08h.82s.62-13.63.89-14.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(95.8 76.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 1.03,
    cy: 1.03,
    r: 1.03,
    transform: "translate(122.83 76.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1447",
    "data-name": "Rectangle 1447",
    width: 2.46,
    height: 0.61,
    transform: "translate(95.68 79.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    "data-name": "Rectangle 1448",
    width: 2.99,
    height: 0.7,
    transform: "translate(122.47 79.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1449",
    "data-name": "Rectangle 1449",
    width: 2.45,
    height: 0.79,
    transform: "translate(94.02 84.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1450",
    "data-name": "Rectangle 1450",
    width: 2.43,
    height: 0.78,
    transform: "translate(94.43 91.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1451",
    "data-name": "Rectangle 1451",
    width: 2.45,
    height: 0.79,
    transform: "translate(122.52 84.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1452",
    "data-name": "Rectangle 1452",
    width: 2.43,
    height: 0.78,
    transform: "translate(122.49 91.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7705",
    "data-name": "Path 7705",
    d: "M99.79,88.93c-.14.66-.29,1.32-.42,1.98-.1.52-.21,1.03-.27,1.55a1.736,1.736,0,0,0,.13.58c.02.07.07.14.05.19-.18.55-.2,1.17-.68,1.59a4.01,4.01,0,0,1-.48.45.418.418,0,0,1-.38-.08c-.07-.08-.04-.26-.02-.39.02-.21.08-.42.09-.64.03-.64.04-1.28.07-1.92.03-.54.06-1.08.11-1.62.1-1.1.24-2.19.32-3.29.03-.39-.08-.78-.08-1.17,0-.53.05-1.07.06-1.6a4.129,4.129,0,0,0-.07-.49c-.15.03-.29.05-.44.08-.42.08-.85.18-1.27.23-.1.01-.24-.14-.31-.25a.746.746,0,0,1-.09-.34,5.728,5.728,0,0,1,.1-2.22c.04-.11.18-.26.26-.26a.527.527,0,0,1,.39.21c.05.08-.02.27-.09.39-.09.17-.32.32-.31.46a5.905,5.905,0,0,0,.3,1.15c.01.04.17.09.23.06.31-.16.6-.35.91-.5a5.248,5.248,0,0,1,.67-.22,2.2,2.2,0,0,0,.71-.24c.25-.21.04-.49-.08-.69a2.12,2.12,0,0,1-.17-1.42c0-.09.16-.18.26-.24.05-.04.14-.03.21-.04.68-.11.8-.03.92.66a1.371,1.371,0,0,1-.06,1.01c-.27.47-.12.79.4.85a3.425,3.425,0,0,1,1.74,1c.17.14.26.11.34-.08s.16-.39.23-.59a.6.6,0,0,0-.2-.75.492.492,0,0,1-.14-.44.7.7,0,0,1,.46-.2c.07,0,.23.15.23.23,0,.83-.03,1.66-.07,2.49-.02.32-.24.39-.51.28-.46-.18-.92-.38-1.41-.59,0,.11-.02.26-.02.4.01.53.03,1.07.04,1.6,0,.04.01.09,0,.1-.42.28-.1.57-.05.88.13.73.25,1.45.32,2.19.06.53.04,1.07.06,1.61,0,.06-.03.12,0,.17.2.5-.04,1,.01,1.51.06.6.1,1.21.18,1.81.02.14.2.25.27.4.05.1.11.27.06.35a.358.358,0,0,1-.33.11,2.508,2.508,0,0,1-.53-.29c-.03-.02-.04-.07-.06-.08-.77-.28-.57-1.09-.86-1.63-.03-.05.02-.15.05-.23s.09-.15.09-.22a12.835,12.835,0,0,0-.16-1.52c-.16-.8-.39-1.59-.59-2.38a.487.487,0,0,1-.12-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1453",
    "data-name": "Rectangle 1453",
    width: 0.08,
    height: 1.92,
    transform: "matrix(0.969, -0.246, 0.246, 0.969, 102.517, 80.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7706",
    "data-name": "Path 7706",
    d: "M102.66,80.31a.878.878,0,0,1,.48-.11,1.317,1.317,0,0,0,.62-.2l.11.62s-.38.28-.58.23a.8.8,0,0,0-.47.1l-.16-.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 0.06,
    cy: 0.06,
    r: 0.06,
    transform: "translate(102.48 80.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7707",
    "data-name": "Path 7707",
    d: "M109.02,85.98a8.139,8.139,0,0,1-.68.58c-.3.21-.52.13-.6-.23a13.291,13.291,0,0,1-.2-1.39.33.33,0,0,1,.12-.24c.22-.17.18-.35.06-.55a2.128,2.128,0,0,1-.27-.59c.09.07.19.13.32.22-.01-.19-.02-.33-.03-.48.02,0,.04-.02.06-.03.05.08.1.15.16.25.01-.12.03-.23.04-.34a.22.22,0,0,0,.08-.01c.03.11.07.22.11.36.03-.09.06-.16.08-.23h.06c.03.17.05.33.09.53.11-.09.19-.16.27-.23.02.01.04.03.06.04-.14.32-.27.64-.41.97.03.03.07.05.1.08.12-.53.59-.54.95-.71a3.346,3.346,0,0,0,.44-.29.349.349,0,0,0,.04-.55,1.325,1.325,0,0,1-.22-.94c.01-.34.35-.55.76-.53a.648.648,0,0,1,.68.64,3.514,3.514,0,0,1-.14.84.533.533,0,0,0,.2.64,2.948,2.948,0,0,0,.76.36.636.636,0,0,1,.53.57c0,.05.04.1.06.16a.355.355,0,0,0,.1-.02c-.06-.42-.12-.84-.19-1.31.09.06.16.1.24.15.04-.18.09-.36.13-.54h.08c.01.1.03.21.04.32.05-.11.09-.2.13-.3.09.07.16.13.28.23-.02.09-.04.25-.08.45.16-.08.27-.14.38-.2.01.01.02.03.04.04-.13.18-.26.36-.4.53-.12.16-.13.29.05.42a.323.323,0,0,1,.12.26c-.03.43-.08.85-.14,1.27-.07.48-.31.59-.71.33a6.107,6.107,0,0,1-.65-.53c-.03.28-.08.52-.09.76-.01.67,0,1.34-.01,2-.01.46-.08.91-.12,1.37a.558.558,0,0,1-.03.22c-.21.7-.43,1.39-.64,2.09-.12.4-.22.8-.34,1.2a.386.386,0,0,0,.18.48s.02.01.02.02c.08.13.16.27.25.4a1.157,1.157,0,0,1-.44.07c-.26-.05-.35.04-.34.29.01.22-.12.29-.32.29a.479.479,0,0,1-.45-.74.282.282,0,0,0-.03-.39.452.452,0,0,1-.08-.29c-.1-1.18-.18-2.36-.3-3.53-.05-.51-.21-1-.23-1.51a6.737,6.737,0,0,1,.09-1.74,5.583,5.583,0,0,0-.02-1.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7708",
    "data-name": "Path 7708",
    d: "M114.26,83.05c-.07,0-.14.02-.18-.01s-.03-.11-.02-.16c.05-.23.1-.45.16-.68a2.863,2.863,0,0,1,.15-.41.19.19,0,0,1,.32-.06.249.249,0,0,0,.27.05.732.732,0,0,1,.7.08.134.134,0,0,0,.09.02.477.477,0,0,1,.52.41,1.606,1.606,0,0,1,0,.31.4.4,0,0,0,.03.15.769.769,0,0,1-.25.71.676.676,0,0,0-.02-.14c-.03.02-.05.04-.09.07-.02-.09-.04-.17-.06-.25a.06.06,0,0,1-.04-.01,1.659,1.659,0,0,0-.14.41c0,.07.11.16.18.22.02.02.1-.03.14-.06a1.432,1.432,0,0,1,.22-.15,6.026,6.026,0,0,0,1.42-.8,7.989,7.989,0,0,1,1.39-.65,5.2,5.2,0,0,0,.72-.42c.15-.09.22-.08.29.08a1.724,1.724,0,0,0,.22.33c.08.11.17.22.25.33l-.09.15c-.09-.1-.19-.22-.3-.32a.37.37,0,0,0-.48-.08,1.983,1.983,0,0,0-.2.11c-.42.24-.85.47-1.27.71-.06.04-.13.08-.18.12-.37.32-.73.66-1.12.96a1.061,1.061,0,0,0-.41.77c-.05.42-.09.84-.11,1.26a4.658,4.658,0,0,0,.26,1.92.319.319,0,0,1,.03.14,54.923,54.923,0,0,1-.52,5.78c-.17.2-.15.27-.05.5a1.353,1.353,0,0,0,.36.53c.07.05.09.18.11.27,0,.03-.06.1-.1.1a2.4,2.4,0,0,1-.46-.05c-.2-.04-.23-.19-.24-.36a.381.381,0,0,0-.03-.1h-.04c-.35.12-.39.1-.41-.27a.811.811,0,0,1,0-.22c.01-.05.06-.09.1-.13.07-.07.17-.12.21-.2a18.245,18.245,0,0,0-.11-2.73c-.11-.25-.13-1.43-.25-1.43-.05,0-.16,1.21-.25,1.47-.02.06-.17,2.7-.1,2.84a.215.215,0,0,0,.12.09c.13.02.15.1.14.21,0,.08-.02.17-.02.25,0,.11-.01.2-.14.23a.2.2,0,0,1-.25-.11.5.5,0,0,0-.06-.08.749.749,0,0,0-.12.2.417.417,0,0,1-.4.36,2.173,2.173,0,0,1-.36.02c-.13-.01-.13-.07-.08-.19a.683.683,0,0,1,.33-.34.507.507,0,0,0,.15-.22c.03-.05.05-.12.08-.17.13-.22.14-.28-.03-.46a30.711,30.711,0,0,1-.53-5.62.281.281,0,0,0,.07-.19c-.05-.31.13-.57.16-.86.02-.15.06-.3.07-.45a7.983,7.983,0,0,0-.08-1.69c-.02-.13,0-.26-.03-.39a1.492,1.492,0,0,0-.48-.78c-.33-.33-.62-.71-.95-1.04-.17-.18-.4-.31-.59-.48-.28-.24-.56-.48-.83-.73a.44.44,0,0,0-.61-.07,3.311,3.311,0,0,1-.33.15.574.574,0,0,0-.04-.07c.06-.04.12-.07.19-.12-.02-.02-.03-.05-.05-.07a.768.768,0,0,0,.61-.59c.06.08.11.13.15.18a1.591,1.591,0,0,0,.2.24c.32.23.66.44.98.67a5.853,5.853,0,0,1,.47.4l.23.2c.19.15.37.3.56.43.24.16.49.31.74.46a2.831,2.831,0,0,1,.28.2c.14.12.15.12.27-.03.04-.05.1-.13.09-.17-.07-.14-.03-.35-.25-.42-.04.07-.08.14-.14.25-.06-.11-.1-.19-.14-.26Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7709",
    "data-name": "Path 7709",
    d: "M94.08,95.22h0L78.9,95.03a.415.415,0,0,1-.44-.37V78.33a.367.367,0,0,1,.19-.31.489.489,0,0,1,.41-.04l15.18,4.68a.38.38,0,0,1,.29.35V94.85a.368.368,0,0,1-.13.27.489.489,0,0,1-.31.11Zm-14.74-.93,14.29.18V83.27l-14.29-4.4V94.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1454",
    "data-name": "Rectangle 1454",
    width: 0.87,
    height: 15.75,
    transform: "translate(81.08 79.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1455",
    "data-name": "Rectangle 1455",
    width: 0.87,
    height: 15.75,
    transform: "translate(84.17 79.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1456",
    "data-name": "Rectangle 1456",
    width: 0.87,
    height: 15.75,
    transform: "translate(87.27 79.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1457",
    "data-name": "Rectangle 1457",
    width: 0.87,
    height: 15.75,
    transform: "translate(90.36 79.06)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7711",
    "data-name": "Path 7711",
    d: "M124.75,95.13a.368.368,0,0,1-.13-.27V83.02a.38.38,0,0,1,.29-.35l15.18-4.68a.528.528,0,0,1,.41.04.355.355,0,0,1,.19.31V94.67a.408.408,0,0,1-.44.37l-15.18.19h0a.469.469,0,0,1-.31-.11ZM139.8,78.88l-14.29,4.4v11.2l14.29-.18V78.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1458",
    "data-name": "Rectangle 1458",
    width: 0.87,
    height: 15.75,
    transform: "translate(138.06 94.83) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1459",
    "data-name": "Rectangle 1459",
    width: 0.87,
    height: 15.75,
    transform: "translate(134.96 94.83) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1460",
    "data-name": "Rectangle 1460",
    width: 0.87,
    height: 15.75,
    transform: "translate(131.88 94.83) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1461",
    "data-name": "Rectangle 1461",
    width: 0.87,
    height: 15.75,
    transform: "translate(128.78 94.83) rotate(180)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1462",
    "data-name": "Rectangle 1462",
    width: 21.36,
    height: 8.3,
    transform: "translate(56.23 86.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1463",
    "data-name": "Rectangle 1463",
    width: 77.59,
    height: 8.3,
    transform: "translate(0 86.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1464",
    "data-name": "Rectangle 1464",
    width: 67.34,
    height: 8.3,
    transform: "translate(141.56 86.71)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 1.7,
    cy: 1.7,
    r: 1.7,
    transform: "translate(185.36 27.12)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 1.7,
    cy: 1.7,
    r: 1.7,
    transform: "translate(201.13 58.39)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 1.7,
    cy: 1.7,
    r: 1.7,
    transform: "translate(191.22 75.14)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 1.7,
    cy: 1.7,
    r: 1.7,
    transform: "translate(5.09 45.93)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 1.7,
    cy: 1.7,
    r: 1.7,
    transform: "translate(32.34 25.56)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 1.84,
    cy: 1.84,
    r: 1.84,
    transform: "translate(40.95 78.42)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7713",
    "data-name": "Path 7713",
    d: "M16.82,8.52H15.28a8.76,8.76,0,0,1-.8,1.05c.68.27,1.27.53,1.76.78l-.63.82c-.85-.39-1.51-.68-1.97-.85a10.836,10.836,0,0,1-3.19,1.08L10,10.44a8.9,8.9,0,0,0,2.34-.59,12.922,12.922,0,0,0-1.65-.5c.4-.43.65-.71.74-.83H10.1V7.65h2.02l.47-.73H10.65V4.81h2.23v-.6H10.62V2.82h-.57V2h.57V.65h2.26V.16h1.06V.65h2.23V2.02h.63v.82h-.63V4.23H13.94v.6H16.2V6.94H13.87l-.46.73h1.16a3.756,3.756,0,0,0,.21-.44l.98.23a.4.4,0,0,1-.07.21h1.14v.87Zm-3.95-6.5V1.45H11.63v.57Zm0,1.42V2.83H11.63v.61Zm0,2.67v-.5h-1.2v.5Zm1.16,2.41H12.77s-.12.16-.3.38l.98.3a4.107,4.107,0,0,0,.57-.68Zm1.1-6.5V1.45h-1.2v.57Zm0,1.41v-.6h-1.2v.6h1.2Zm.04,2.68v-.5H13.93v.5Zm6.15,4.32-.56.95A7.532,7.532,0,0,1,18.88,9.5a9.647,9.647,0,0,1-1.75,1.85l-.74-.84a8.186,8.186,0,0,0,1.85-2.02,9.061,9.061,0,0,1-.95-2.55l.98-.54a10.539,10.539,0,0,0,.54,1.78,16.259,16.259,0,0,0,.55-4.17h-.94a13.2,13.2,0,0,1-1.19,2.7l-.73-.92A14.966,14.966,0,0,0,17.98.06l1.08.16c-.05.37-.17.94-.34,1.73h2.44V3.01h-.7a16.039,16.039,0,0,1-.97,5.48,7.315,7.315,0,0,0,1.85,1.95Z",
    fill: "#795698"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7714",
    "data-name": "Path 7714",
    d: "M26.37.36a16.5,16.5,0,0,1-.65,1.63l-.44.93v8.37H24.14V4.87a11.121,11.121,0,0,1-.93,1.14l-.51-1.2A15.177,15.177,0,0,0,25.24.08l1.14.28Zm7.57,10.59H25.7V9.83h2.11a59.328,59.328,0,0,0-.94-5.91l.79-.54H26.01V2.24h3.33a14.543,14.543,0,0,0-.7-1.91L29.77.06a19.214,19.214,0,0,1,.74,2.18h3.11V3.38H31.94l.92.56q-.33,2.91-.94,5.88h2.02v1.12ZM31.76,3.38H27.9q.54,2.325,1.05,6.44h1.79a54.813,54.813,0,0,0,1.02-6.44Z",
    fill: "#795698"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7715",
    "data-name": "Path 7715",
    d: "M46.8,9.99l-.22,1.08c-.45,0-.94.01-1.46.01-1.27,0-2.4-.03-3.39-.08a5.893,5.893,0,0,1-2.4-.56,3.959,3.959,0,0,1-1.5-1.34,9.771,9.771,0,0,1-1.63,2.29l-.74-.92a6.96,6.96,0,0,0,1.99-4.65h1.2a13.467,13.467,0,0,1-.4,2.09A3.542,3.542,0,0,0,40.8,9.74V5.09H35.57V4.04h4.94V2.68H36.44V1.63h4.07V.17h1.18V1.63h4.12V2.68H41.69V4.04h4.94V5.09H41.96V6.83h3.93V7.9H41.96V9.89c1.22.08,2.43.12,3.62.12.42,0,.82,0,1.22-.01Z",
    fill: "#795698"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7716",
    "data-name": "Path 7716",
    d: "M52.04,2.34H48.35V1.31h1.38a4.659,4.659,0,0,0-.49-1L50.39,0a7.549,7.549,0,0,1,.54,1.3h1.11V2.33Zm-.09,1.9H48.63V3.22h3.32Zm0,1.92H48.63V5.11h3.32Zm0,4.89H50.88v-.5H49.72v.74H48.65V7.02h3.3v4.04ZM50.88,9.48V8.05H49.72V9.48Zm8.05.38H54.97l.46.47a12.866,12.866,0,0,1-2.68,1.01l-.55-.83a12.5,12.5,0,0,0,2.12-.65H52.93V5.73h5.99V9.86Zm.52-8.33H56.48v.49h2.67v.77H52.72V2.02h2.67V1.53H52.43V.66h2.98V.16h1.07v.5h2.96v.87Zm-.19,3.82H52.64V3.18h6.62ZM54.52,4.6V3.89h-.87V4.6Zm3.35,2.33V6.51H54.01v.42Zm0,1.06V7.54H54.01v.45Zm0,1.04V8.59H54.01v.44ZM56.37,4.6V3.89h-.9V4.6Zm3.24,5.98-.5.8a15.968,15.968,0,0,0-2.55-.6l.51-.83A15.979,15.979,0,0,1,59.61,10.58ZM58.26,4.6V3.89h-.91V4.6Z",
    fill: "#795698"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(72.54 3.06)",
    fill: "#8891c7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(87.01 3.06)",
    fill: "#dbc69a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(101.47 3.06)",
    fill: "#b092bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(130.4 3.06)",
    fill: "#cdd78d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(144.87 3.06)",
    fill: "#debcb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(159.33 3.06)",
    fill: "#9e8a79"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(173.79 3.06)",
    fill: "#9bb398"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(188.26 3.06)",
    fill: "#648e9a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(115.94 3.06)",
    fill: "#6fb1be"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyArt);
export default __webpack_public_path__ + "static/media/key-art.742a1a34fe714981030e710fafe4563b.svg";
export { ForwardRef as ReactComponent };